import { HTMLAttributes } from "react";

export const Loader = ({ className, ...props }: HTMLAttributes<HTMLSpanElement>) => (
  <span
    {...props}
    className={['loader', className].join(' ')}
  />
)